'use client';
import { datadogRum } from '@datadog/browser-rum';
import { env } from '@ria-client/env';
import { getBotCookies } from '@ria-client/utils/cookies';
import { useEffect } from 'react';

/*
 * Datadog RUM. Guard init with getInitConfiguration(); always startView on mount
 * (trackViewsManually — remounts must still record the destination view).
 */

export function DataDogProvider() {
  useEffect(() => {
    if (!env.NEXT_PUBLIC_DD_APP_ID || !env.NEXT_PUBLIC_DD_CLIENT_TOKEN) return;

    if (!datadogRum.getInitConfiguration()) {
      const { isBot, isVerifiedBot, botScore } = getBotCookies();

      datadogRum.init({
        applicationId: env.NEXT_PUBLIC_DD_APP_ID,
        clientToken: env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: 'ria-client',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 5,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        traceSampleRate: 100,
        trackViewsManually: true,
        defaultPrivacyLevel: 'mask-user-input',
        env: env.NEXT_PUBLIC_DEPLOYABLE_ENV,
        version: env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
        allowedTracingUrls: [
          /https:\/\/ria-client-pr-\d+-production\.vercel\.stage\.nerdwallet\.biz\//,
          /https:\/\/ria-client-pr-\d+\.vercel\.stage\.nerdwallet\.biz\//,
          (url: string) => url.startsWith(env.NEXT_PUBLIC_NW_URL),
          (url: string) => url.startsWith(env.SECTION_SPECIFIC_ML_CLOUDFRONT_URL),
        ],
      });

      datadogRum.setUserProperty('is_bot', isBot);
      datadogRum.setUserProperty('is_verified_bot', isVerifiedBot);
      datadogRum.setUserProperty('bot_score', botScore);
    }

    datadogRum.startView({
      name: window.location.pathname,
      service: 'ria-client',
    });
  }, []);
  return null;
}
